<template>
    <v-flex grow>
        <v-list two-line subheader class="transparent">
            <v-list-tile
                    v-for="scenario in scenarioList"
                    :key="scenario.id"
                    avatar
            >
                <v-list-tile-avatar ripple @click="scenarioCallback(scenario.id)">
                    <v-icon v-if="scenario.id === selectedScenarioId" large color="green darker-4">mdi-alpha-s-circle
                    </v-icon>
                    <v-icon v-else large>mdi-alpha-s-circle</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content ripple @click="scenarioCallback(scenario.id)">
                    <v-list-tile-title><strong>{{ scenario.id }} </strong> : {{ scenario.description }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title><strong>Organization: </strong> {{
                        scenario.organizationName }}
                    </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action @click="toggleScenarioInfoDialog(scenario)">
                    <v-btn icon ripple>
                        <v-icon color="grey lighten-1">info</v-icon>
                    </v-btn>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
        <v-dialog
                v-model="scenarios.showScenarioInfoDialog"
                max-width="500"
        >
            <v-card>
                <v-flex tag="strong" xs12 text-xs-center ma-0 pa-0>
                    <v-card-title class="headline text-xs-center">Scenario {{ scenarios.scenarioDetails.id }}
                    </v-card-title>
                </v-flex>
                <v-card-text>
                    <v-layout
                            tag="v-card-text"
                            text-xs-left
                            row wrap
                    >
                        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Name:</v-flex>
                        <v-flex xs5>{{ scenarios.scenarioDetails.scenarioName }}</v-flex>
                        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Description:</v-flex>
                        <v-flex xs5>{{ scenarios.scenarioDetails.description }}</v-flex>
                        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Organization Id:</v-flex>
                        <v-flex xs5>{{ scenarios.scenarioDetails.organizationId }}</v-flex>
                        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Organization Name:</v-flex>
                        <v-flex xs5>{{ scenarios.scenarioDetails.organizationName }}</v-flex>
                        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Creation Date:</v-flex>
                        <v-flex xs5>{{ scenarios.scenarioDetails.creationDate }}</v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat="flat" @click="toggleScenarioInfoDialog()">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>


<script>
    import {mapGetters, mapState,} from "vuex";

    export default {
        name: "ScenarioSelection",
        components: {},
        props: ["scenarioList", "selectedScenarioId", "scenarioCallback"],
        data() {
            return {
                scenarios: {
                    showScenarioInfoDialog: false,
                    scenarioDetails: {}
                },
            };
        },
        computed: {
            ...mapState({}),
            ...mapGetters("FileInputState", {
                fileInputs: "getFileInputs",
                fileInLoading: "getFileInLoading",
            }),
        },
        methods: {
            toggleScenarioInfoDialog(scenario) {
                this.scenarios.showScenarioInfoDialog = !this.scenarios.showScenarioInfoDialog;
                if (scenario !== undefined) {
                    this.scenarios.scenarioDetails = scenario;
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .input-form-description {
        position: relative;
        top: 45%;
    }

    .box {
        display: block;
        background-color: white;
        outline: 2px dashed black;
        outline-offset: -10px;
        text-align: center;
        height: 100%;
        border-radius: 4px;
    }

    .box__dragndrop,
    .box__uploading,
    .box__success,
    .box__error {
        display: none;
    }

    .box__has-advanced-upload.box__dragndrop {
        display: inline;
    }

    .box.box__is-dragover {
        background-color: #F2F5FA;
        outline: 2px dashed grey;
        outline-offset: -20px;
    }
</style>
